/* eslint-disable */
import { Switch, Route, Redirect } from "react-router-dom";
import { protectedRoutes, publicRoutes } from "./Routes";

const Authmiddleware = () => {
  const isLoggedIn = !!localStorage.getItem("userInfo") && !!localStorage.getItem("token");

  return (
    <Switch>
      {/* Render all routes */}
      {(isLoggedIn ? protectedRoutes : publicRoutes).map((route) => (
        <Route
          key={route.path}
          path={route.path}
          exact
          render={(props) => {
            const Component = route.component;
            return <Component {...props} />;
          }}
        />
      ))}

      {/* Default redirects */}
      <Redirect to={isLoggedIn ? "/admin/dashboard" : "/"} />
    </Switch>
  );
};

export default Authmiddleware;
